const checkoutPageEN = {
    activateTitle: "Activate Your Shop",
    activateSubtitle: "Complete your subscription to start accepting bookings.",
    totalSeats: "Total Seats",
    staffSeats: "Staff Seats",
    poweredBy: "Secure payments powered by Paddle",
    stillThere: "Are you still there?",
    continue: "Continue",
    shopLive: "Congratulations! Your shop is now live and visible to the public."

};
export default checkoutPageEN